import React from 'react';
import DateTimeDisplay from './DateTimeDisplay';
import { useCountdown } from '../hooks/useCountdown';
import './styles/countdown.css'

const ExpiredNotice = ({onClaim, idSlot, risky, setIsRisky}) => {
    return (
      <div className="expired-notice">
        <button className='editteam_btn' onClick={() => {
          if(risky !== undefined){
            if(Number(idSlot) === 6){
              if(Number(risky.slot_risky_1) === 1){
                const id_risky = Number(idSlot) + 2;
                setIsRisky(true);
                onClaim(id_risky)
              }
              else{
                onClaim(idSlot)
              }
            }
            else if(Number(idSlot) === 7){
              if(Number(risky.slot_risky_2) === 1){
                const id_risky = Number(idSlot) + 2;
                setIsRisky(true);
                onClaim(id_risky)
              }
              else{
                onClaim(idSlot)
              }
            }
          }else {
            onClaim(idSlot)
          }
        }}>Claim</button>
      </div>
    );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
    return (
      <div className="show-counter">
          <DateTimeDisplay value={days} type={'Days'} isDanger={false} />
          <p>:</p>
          <DateTimeDisplay value={hours} type={'Hours'} isDanger={false} />
          <p>:</p>
          <DateTimeDisplay value={minutes} type={'Mins'} isDanger={minutes <= 10 && minutes > 0} />
          <p>:</p>
          <DateTimeDisplay value={seconds} type={'Seconds'} isDanger={Number(minutes) === 0} />
      </div>
    );
};

const CountdownTimer = ({ targetDate, onClaim, idSlot, risky, setIsRisky }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice onClaim={onClaim} idSlot={idSlot} risky={risky} setIsRisky={setIsRisky} />;
  } else {
    return (
      <ShowCounter
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    );
  }
};

export default CountdownTimer;